"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useInterval;

var _react = require("react");

/** Call a function on an interval
 * @param callback the function to call on every interval
 * @param interval amount of miliseconds between every function call
 */
function useInterval(callback, delay) {
  var savedCallback = (0, _react.useRef)(callback); // Remember the latest callback

  (0, _react.useEffect)(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval

  (0, _react.useEffect)(function () {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }
  }, [delay]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy91c2VJbnRlcnZhbC50cyJdLCJuYW1lcyI6WyJ1c2VJbnRlcnZhbCIsImNhbGxiYWNrIiwiZGVsYXkiLCJzYXZlZENhbGxiYWNrIiwiY3VycmVudCIsInRpY2siLCJpZCIsInNldEludGVydmFsIiwiY2xlYXJJbnRlcnZhbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBO0FBQ0E7QUFDQTtBQUNBO0FBQ2UsU0FBU0EsV0FBVCxDQUFxQkMsUUFBckIsRUFBb0NDLEtBQXBDLEVBQTJEO0FBQ3hFLE1BQU1DLGFBQWEsR0FBRyxtQkFBT0YsUUFBUCxDQUF0QixDQUR3RSxDQUd4RTs7QUFDQSx3QkFBVSxZQUFNO0FBQ2RFLElBQUFBLGFBQWEsQ0FBQ0MsT0FBZCxHQUF3QkgsUUFBeEI7QUFDRCxHQUZELEVBRUcsQ0FBQ0EsUUFBRCxDQUZILEVBSndFLENBUXhFOztBQUNBLHdCQUFVLFlBQU07QUFDZCxhQUFTSSxJQUFULEdBQWdCO0FBQ2RGLE1BQUFBLGFBQWEsQ0FBQ0MsT0FBZDtBQUNEOztBQUNELFFBQUlGLEtBQUssS0FBSyxJQUFkLEVBQW9CO0FBQ2xCLFVBQU1JLEVBQUUsR0FBR0MsV0FBVyxDQUFDRixJQUFELEVBQU9ILEtBQVAsQ0FBdEI7QUFDQSxhQUFPO0FBQUEsZUFBTU0sYUFBYSxDQUFDRixFQUFELENBQW5CO0FBQUEsT0FBUDtBQUNEO0FBQ0YsR0FSRCxFQVFHLENBQUNKLEtBQUQsQ0FSSDtBQVNEIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlRWZmZWN0LCB1c2VSZWYgfSBmcm9tICdyZWFjdCc7XG5cbi8qKiBDYWxsIGEgZnVuY3Rpb24gb24gYW4gaW50ZXJ2YWxcbiAqIEBwYXJhbSBjYWxsYmFjayB0aGUgZnVuY3Rpb24gdG8gY2FsbCBvbiBldmVyeSBpbnRlcnZhbFxuICogQHBhcmFtIGludGVydmFsIGFtb3VudCBvZiBtaWxpc2Vjb25kcyBiZXR3ZWVuIGV2ZXJ5IGZ1bmN0aW9uIGNhbGxcbiAqL1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlSW50ZXJ2YWwoY2FsbGJhY2s6IGFueSwgZGVsYXk/OiBudW1iZXIgfCBudWxsKSB7XG4gIGNvbnN0IHNhdmVkQ2FsbGJhY2sgPSB1c2VSZWYoY2FsbGJhY2spO1xuXG4gIC8vIFJlbWVtYmVyIHRoZSBsYXRlc3QgY2FsbGJhY2tcbiAgdXNlRWZmZWN0KCgpID0+IHtcbiAgICBzYXZlZENhbGxiYWNrLmN1cnJlbnQgPSBjYWxsYmFjaztcbiAgfSwgW2NhbGxiYWNrXSk7XG5cbiAgLy8gU2V0IHVwIHRoZSBpbnRlcnZhbFxuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIGZ1bmN0aW9uIHRpY2soKSB7XG4gICAgICBzYXZlZENhbGxiYWNrLmN1cnJlbnQoKTtcbiAgICB9XG4gICAgaWYgKGRlbGF5ICE9PSBudWxsKSB7XG4gICAgICBjb25zdCBpZCA9IHNldEludGVydmFsKHRpY2ssIGRlbGF5KTtcbiAgICAgIHJldHVybiAoKSA9PiBjbGVhckludGVydmFsKGlkKTtcbiAgICB9XG4gIH0sIFtkZWxheV0pO1xufVxuIl19